// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","443":"social","903":"games"}[chunkId] + "." + {"177":"23cfbb11","443":"4c95ff99","903":"17cbf422"}[chunkId] + ".js";
};